import { ReactNode } from 'react';
import { SnackbarProvider } from 'notistack';
import StyledMaterialDesignContent from '../theme/snackbar';

type SnackbarWrapperProps = {
  children: ReactNode;
};

function SnackbarWrapper({ children }: SnackbarWrapperProps) {
  return (
    <SnackbarProvider
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
      }}
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={2000}
      preventDuplicate
      dense
    >
      {children}
    </SnackbarProvider>
  );
}

export default SnackbarWrapper;
